import api from './api.js';

export async function getNotifications(page = 1, limit = 20) {
  const response = await api.get('/notifications', { params: { page, limit } });
  return response.data;
}

export async function getUnreadCount() {
  const response = await api.get('/notifications/unread-count');
  return response.data;
}

export async function markAsRead(id) {
  const response = await api.patch(`/notifications/${id}/read`);
  return response.data;
}

export async function markAllAsRead() {
  const response = await api.patch('/notifications/read-all');
  return response.data;
}

export async function getStreamToken() {
  const response = await api.post('/notifications/stream-token');
  return response.data;
}

export async function savePushSubscription(subscription) {
  const response = await api.post('/notifications/push-subscription', { subscription });
  return response.data;
}

export async function removePushSubscription(endpoint) {
  const response = await api.delete('/notifications/push-subscription', { data: { endpoint } });
  return response.data;
}

export async function getVapidPublicKey() {
  const response = await api.get('/notifications/vapid-public-key');
  return response.data;
}

export async function getSettings() {
  const response = await api.get('/notifications/settings');
  return response.data;
}

export async function updateSettings(eventType, updates) {
  const response = await api.patch(`/notifications/settings/${eventType}`, updates);
  return response.data;
}

// ── Per-user preferences (per category) ───────────────────────────────────

export async function getPreferences() {
  const response = await api.get('/notifications/preferences');
  return response.data;
}

export async function updatePreference(category, updates) {
  const response = await api.patch(`/notifications/preferences/${category}`, updates);
  return response.data;
}
